import { render, staticRenderFns } from "./GuideForDownloadApp.vue?vue&type=template&id=9b531c3c&scoped=true&"
import script from "./GuideForDownloadApp.vue?vue&type=script&lang=js&"
export * from "./GuideForDownloadApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b531c3c",
  null
  
)

export default component.exports